import { createContext, useState } from "react";

export const BookingDetailContext = createContext();

export const useManageBookingContext = () => useContext(BookingDetailContext);

function BookingDetailsContextProvider({ children }) {
  const [manageBookingTrip, setManageBookingTrip] = useState();
  const [currentBookingInStateData, setCurrentBookingInStateData] = useState();
  const [currentBoardingPassInStateData, setBoardingPassInStateData] = useState();
  const [boardingPassData, setBoardingPassData] = useState();
  const [baggageAllowanceData, setBaggageAllowanceData] = useState();
  const [segmentKeyData, setSegmentKeyData] = useState();

  const values = {
    manageBookingTrip,
    currentBookingInStateData,
    boardingPassData,
    currentBoardingPassInStateData,
    baggageAllowanceData,
    segmentKeyData,
    setCurrentBookingInStateData,
    setBoardingPassInStateData,
    setBoardingPassData,
    setBaggageAllowanceData,
    setSegmentKeyData
  };

  return <BookingDetailContext.Provider value={values}>{children}</BookingDetailContext.Provider>;
}

export default BookingDetailsContextProvider;
